<template>
  <component :is="group ? 'div' : 'label'" class="st-field" :class="{ 'st-field--inline': inline }">
    <span v-if="label" class="st-field__label st-eyebrow" :class="{ 'on-shell': onShell }">
      {{ label }}
    </span>
    <div class="st-field__control">
      <slot />
    </div>
    <span v-if="error" class="st-field__msg st-field__msg--error">{{ error }}</span>
    <span v-else-if="hint" class="st-field__msg">{{ hint }}</span>
  </component>
</template>

<script setup lang="ts">
defineProps<{
  label?: string;
  hint?: string;
  error?: string;
  /** Lay the label beside the control instead of above it. */
  inline?: boolean;
  onShell?: boolean;
  /**
   * Render as a plain <div> instead of a <label>. Use for composite controls
   * (e.g. a list of chips with their own buttons): a <label> forwards stray
   * clicks to its first nested control, which would fire the first chip's
   * remove button when clicking empty space in the field.
   */
  group?: boolean;
}>();
</script>

<style scoped>
.st-field {
  display: flex;
  flex-direction: column;
  gap: var(--st-space-1);
}
.st-field--inline {
  flex-direction: row;
  align-items: center;
  gap: var(--st-space-3);
}
.st-field--inline .st-field__label {
  flex-shrink: 0;
}
.st-field--inline .st-field__control {
  flex: 1;
  min-width: 0;
}
.st-field__label.on-shell {
  color: var(--st-shell-text-muted);
}
.st-field__msg {
  font-size: var(--st-text-xs);
  color: var(--st-text-subtle);
}
.st-field__msg--error {
  color: var(--st-danger);
}
</style>
